import React from 'react';
import { Stack, Typography, TypographyProps } from '@mui/material';
import {
  CalendarMonth as CalendarMonthIcon,
  Tv as TvIcon,
  Timelapse as TimelapseIcon,
} from '@mui/icons-material';
import momentTimezone from 'moment-timezone';
import moment from 'moment';

import { ICourseForAdmin } from '../../../../../store/V2/CoursesSlice';
import CourseTutorDetailCardWithPopOver from '../../../../../components/Card/CourseTutorDetailCardWithPopOver';

interface ClassDetailViewerProps {
  course: ICourseForAdmin;
}

const classDetailItemStyles: TypographyProps = {
  fontWeight: 400,
  fontSize: '16px',
  color: '#334155',
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
};

const ClassDetailViewer: React.FC<ClassDetailViewerProps> = ({ course }) => {
  let formatedClassTime = '';
  let formatedStartDate = '';
  let formatedEndDate = '';
  let noOfClasses = '';
  let formatedClassDuration = '';

  const classDay = course.classDay || '';

  if (course.classTime) {
    const utcMoment = momentTimezone.tz(course.classTime, 'HH:mm', 'UTC');

    formatedClassTime = utcMoment
      .clone()
      .tz(moment.tz.guess())
      .format('hh:mm A');
  }

  if (course.startDate) {
    formatedStartDate = moment(course.startDate).format('MMM D, YYYY');
  }

  if (course.endDate) {
    formatedEndDate = moment(course.endDate).format('MMM D, YYYY');
  }

  if (course.noOfClasses) {
    noOfClasses = course.noOfClasses.toString();
  }

  if (course.duration) {
    const _hours = Math.floor(course.duration / 60);
    const _mins = course.duration % 60;

    if (_hours) {
      formatedClassDuration = `${_hours} hr`;

      if (_mins) {
        formatedClassDuration += ` ${_mins} min`;
      }
    } else {
      formatedClassDuration += ` ${_mins} min`;
    }
  }

  return (
    <>
      <div>
        <div style={{ marginBottom: '10px' }}>
          <Typography {...classDetailItemStyles}>
            {classDay ? (
              <>
                <CalendarMonthIcon fontSize="small" />
                &nbsp;&nbsp;Every&nbsp;
                <b>{classDay || '-'}</b>
              </>
            ) : null}
            {formatedClassTime ? (
              <>
                {classDay ? <>&nbsp;</> : null}
                at&nbsp;
                <b>{formatedClassTime}</b>
              </>
            ) : null}
            {formatedStartDate ? (
              <>
                {formatedClassTime ? <>&nbsp;</> : null}
                from&nbsp;
                <b>{formatedStartDate}</b>
              </>
            ) : null}
            {formatedEndDate ? (
              <>
                {formatedStartDate ? <>,&nbsp;</> : null}
                until&nbsp;
                <b>{formatedEndDate}</b>.
              </>
            ) : null}
            {noOfClasses ? (
              <>
                &nbsp;&nbsp;
                <TvIcon fontSize="small" />
                &nbsp;&nbsp;
                <b>No. of Classes - {noOfClasses}</b>
              </>
            ) : null}
          </Typography>
          {formatedClassDuration ? (
            <Typography {...classDetailItemStyles} mt="22px">
              {/* {noOfClasses ? <>&nbsp;&nbsp;</> : null} */}
              <TimelapseIcon fontSize="small" />
              &nbsp;&nbsp;
              <b>Duration of a class - {formatedClassDuration}</b>
            </Typography>
          ) : null}
        </div>
      </div>
      {course.tutors && course.tutors.length ? (
        <div style={{ marginTop: '30px' }}>
          <Stack direction="row" alignItems="center" flexWrap="wrap" gap={2}>
            {course.tutors.map((item, index) => (
              <CourseTutorDetailCardWithPopOver
                showFullName
                key={`tutor-${item._id}`}
                courseTutor={item}
                subject={course.subject}
                containerStyles={index === 0 ? { ml: '-7px' } : undefined}
              />
            ))}
          </Stack>
        </div>
      ) : null}
    </>
  );
};

export default ClassDetailViewer;
